
<template>
  <div class="main_empty"
       v-if="propJson.isShow">
    <div class="shadow"></div>
    <div class="footer">

      <p class="title">{{propJson.title}}</p>
      <ul class="box">
        <li class="pd"><span>{{propJson.label1?propJson.label1:'总利息'}}</span><span class="black">{{propJson.interest}}</span></li>
        <p class="line_dashed">
        </p>
        <li class=""><span>{{propJson.label2?propJson.label2:'预估每期还款额元'}}</span><span class="black">{{propJson.periodAmount}}</span></li>
        <li class=""><span>{{propJson.label3?propJson.label3:'费用描述'}}</span><span class="black">{{propJson.feeDesc}}</span></li>
        <p class="line_dashed">
        </p>
        <div class="pay_btn pay_btn_succ"
             @click="toHide">{{propJson.btn}}</div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['propJson'],
  data () {
    return {
    }
  },
  mounted () {

  },

  methods: {
    //跳转客户端
    toPay () {
      let json = {
        productId: this.productId,
        memberOrderSource: '1',
        scenceCode: this.scenceCode,
        memberType: this.currentMemberTypeId,
        payMoney: this.currentPayMoney,
        orderId: this.orderId,
        aaa: this.aaa,
      }
      if (this.currentPayMoney.slice(0, 1) == "￥") {
        json.payMoney = json.payMoney.slice(1)
      }
      // console.log(json)
      // if (!this.noJson) {
      //   json = {};
      // }
      if (this.currentPayWay == 36){  //0: 支付宝 1:微信
        json.payType = 0;
      }else{
        json.payType = 1;
      }
      if (this.currentPayWay == 36) {
        this.$get("/app/v1.0/pay/paySelect")
                .then((res) => {
                  if (res.code == 200) {
                    let result = res.data;
                    if(result == 1){
                      try {
                        window.webkit.messageHandlers.toYsePay.postMessage(json); //ios
                      } catch (err) {
                        window.AppJs.toYsePay(JSON.stringify(json)); //android
                      }
                    }else{
                      try {
                        window.webkit.messageHandlers.toAliPay.postMessage(json); //ios
                      } catch (err) {
                        window.AppJs.toAliPay(JSON.stringify(json)); //android
                      }
                    }
                  } else {
                    this.util.toast({msg: res.message});
                  }
                })
                .catch((error) => {
                });
      }
      /*if (this.currentPayWay == 36) {//支付宝支付
        try {
          window.webkit.messageHandlers.toAliPay.postMessage(json);//ios
        } catch (err) {
          window.AppJs.toAliPay(JSON.stringify(json));//android
        }
      } else {//微信支付
        try {
          window.webkit.messageHandlers.toWexinPay.postMessage(json);//ios
        } catch (err) {
          window.AppJs.toWexinPay(JSON.stringify(json));//android
        }
      }*/

    },
    toHide () {
      this.$parent.propJson.isShow = false;
    },
    checkPay (index, item) {
      this.currentPayWay = item.page;
      this.isActive = index;
    },
    toArgeement () {
      // this.$router.push({
      //   path: '/vip/agreement'
      // })
      window.location.href = "https://thread.yanhugame.com/agreement/会员服务协议.html"
    }
  }
}
</script>
<style scoped>
.main_empty {
  width: 100%;
  height: 100%;
}
.shadow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 11;
}
.color3 {
  color: #333;
}
.footer {
  position: fixed;
  top: 50%;
  left: 50%;
  /* background: #fff; */
  z-index: 111;
  width: 2.75rem;
  transform: translate(-50%, -50%);
  padding-top: 0.44rem;
  border-radius: 10px;
}

.pay_btn {
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.5) 0%,
    rgba(81, 117, 241, 0.5) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.4rem;
  line-height: 0.4rem;
  width: 1.45rem;
  margin: 0 auto;
  margin-top: 0.19rem;
}
.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
.logo,
.logo_succ {
  display: block;
  width: 0.99rem;
  height: 0.85rem;
  background: url('../assets/img/afterLoan/rep_fail.png') no-repeat center
    center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.line_dashed {
  width: 88%;
  height: 2px;
  background: url('../assets/img/afterLoan/dashed.png') no-repeat center center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.logo_succ {
  background: url('../assets/img/afterLoan/rep_succ.png') no-repeat center
    center;
  background-size: 100% 100%;
}
.title {
  font-size: 0.16rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 0.9rem;
  background: url('../assets/img/afterLoan/toast_bg.png') no-repeat center
    center;
  background-size: 100% 100%;
  padding-top: 0.18rem;
}
.info {
  width: 76%;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin: 0 auto;
  text-align: center;
  margin-bottom: 0.23rem;
  line-height: 28px;
}
.box {
  background: #fff;
  position: relative;
  top: -1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding-bottom: 0.2rem;
}

.list {
  color: #999;
  font-size: 0.14rem;
  padding: 0 0.15rem;
  padding-bottom: 0.1rem;
}
.box li {
  color: #999;
  font-size: 0.14rem;
  padding: 0.1rem 0.15rem;
  display: flex;
  justify-content: space-around;
  /* border: 1px dashed #ccc; */
}
.box li span {
  flex: 5;
}
.box li .black {
  flex: 5;
  color: #333;
  text-align: left;
}

.box .pd {
  padding-top: 0;
}
</style>
